var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardTick = function SvgCardTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A75BB",
    d: "M9.563 6.552H1.417a.535.535 0 0 1-.531-.531c0-.29.24-.531.531-.531h8.146c.29 0 .531.24.531.53s-.24.532-.531.532M5.667 12.219H4.25a.535.535 0 0 1-.531-.531c0-.29.24-.532.531-.532h1.417c.29 0 .53.241.53.531s-.24.532-.53.532M10.27 12.219H7.439a.535.535 0 0 1-.532-.531c0-.29.241-.532.532-.532h2.833c.29 0 .531.241.531.531s-.24.532-.531.532"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A75BB",
    d: "M12.439 15.052H4.562c-2.82 0-3.676-.85-3.676-3.64V5.588c0-2.791.857-3.641 3.676-3.641h5c.291 0 .532.24.532.531 0 .29-.24.531-.531.531H4.562c-2.224 0-2.614.383-2.614 2.579v5.815c0 2.196.39 2.579 2.614 2.579h7.87c2.224 0 2.613-.383 2.613-2.579V7.806c0-.29.241-.531.532-.531.29 0 .53.24.53.53v3.6c.008 2.797-.85 3.647-3.668 3.647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A75BB",
    d: "M12.75 5.844a.53.53 0 0 1-.375-.156l-1.063-1.063a.534.534 0 0 1 0-.75.534.534 0 0 1 .751 0l.687.687 2.458-2.458a.534.534 0 0 1 .75 0 .534.534 0 0 1 0 .75l-2.832 2.834a.53.53 0 0 1-.376.156"
  })));
};
export default SvgCardTick;